import React from 'react';
import { AboutSection } from '../components/sections/AboutSection';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
interface NosotrosPageProps {
  onBack: () => void;
}
export function NosotrosPage({
  onBack
}: NosotrosPageProps) {
  useDocumentMeta({
    title: 'Nosotros | Fabricante de alineadores invisibles en Colombia',
    description: 'Conoce a Alinova: empresa colombiana que fabrica alineadores invisibles para odontólogos y ortodoncistas, con certificación INVIMA y respaldo clínico en cada caso.',
    path: '/nosotros'
  });
  return <main data-id="element-912" data-mp="1hpvp75yr8oe2">
      <AboutSection onBack={onBack} data-id="element-913" data-mp="1csdbl29slkzq" />
    </main>;
}